/**
 * Route for `igaming-player-ltv-per-affiliate`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingPlayerLtvPerAffiliatePage } from "../features/igaming-player-ltv-per-affiliate/IgamingPlayerLtvPerAffiliatePage";

export const igamingPlayerLtvPerAffiliateRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-player-ltv-per-affiliate",
	component: IgamingPlayerLtvPerAffiliatePage,
});

export default igamingPlayerLtvPerAffiliateRoute;
